import nordstrom1 from "../assets/nordstrom/nordstrom1.png";
import nordstrom2 from "../assets/nordstrom/nordstrom2.png";
import nordstrom3 from "../assets/nordstrom/nordstrom3.png";
import nordstrom4 from "../assets/nordstrom/nordstrom4.png";

import box8_1 from "../assets/box8/box8_1.png";
import box8_2 from "../assets/box8/box8_2.png";
import box8_3 from "../assets/box8/box8_3.png";
import box8_4 from "../assets/box8/box8_4.png";
import box8_5 from "../assets/box8/box8_5.png";

import chatNow1 from "../assets/chatNow/1.png";
import chatNow2 from "../assets/chatNow/2.png";
import chatNow3 from "../assets/chatNow/3.png";
import chatNow4 from "../assets/chatNow/4.png";
import chatNow5 from "../assets/chatNow/5.png";


export const projectsData = [
  {
    id: 1,
    title: "Nordstrom-Clone",
    description:
      "nordstrom is a leading fashion retailer offering clothing, shoes, and accessories for men, women and kids.. Where we have used HTML, CSS and Advance Javascript to acheive this. In this project we have tried to clone the “Nordstorm” website.",
    techStack: ["Html","CSS", "JavaScript"],
    githubURL: "https://github.com/vibrantachintya/nordstrom",
    deployedURL: "https://vibrantachintya.github.io/nordstrom/",
    images: [nordstrom1, nordstrom2, nordstrom3, nordstrom4],
  },
  {
    id: 2,
    title: "Box8-Clone",
    description:
      "Box8 is a Online food ordering website where you can order different items of food through online.",
    techStack: ["ReactJS", "JavaScript","Mongoose", "MongoDB", "NodeJS", "Express"],
    githubURL: "https://github.com/Gourav135/Box8-Frontend",
    deployedURL: "https://box8-project.vercel.app",
    images: [box8_1, box8_2, box8_3, box8_4,box8_5],
  },
  {
    id: 3,
    title: "ChatNow Socket.io app",
    description:
      "ChatNow is an Application made using React, Node.js and Socket.io with MongoDB.You can chat with registered people.It is a real-time chat application.",
    techStack: ['React.js',"Node.js","MongoDB","Socket.io","Express.js", "JavaScript"],
    githubURL: "https://github.com/Surajmicky/Chat_client",
    deployedURL: "https://suraj-chat-now.vercel.app/register",
    images: [chatNow1,chatNow2,chatNow3,chatNow4,chatNow5],
  },
 
];
